import type { AnchorHTMLAttributes } from "react";
import type { Components } from "react-markdown";
import { Link } from "react-router-dom";

type MarkdownLinkProps = AnchorHTMLAttributes<HTMLAnchorElement> & {
  // react-markdown passes the AST node alongside the HTML props; we don't use it.
  node?: unknown;
};

export function MarkdownLink({
  href,
  target,
  rel,
  children,
  node: _node,
  ...rest
}: MarkdownLinkProps) {
  if (!href) {
    return <a {...rest}>{children}</a>;
  }

  if (href.startsWith("/")) {
    return (
      <Link to={href} {...rest}>
        {children}
      </Link>
    );
  }

  if (href.startsWith("#") || href.startsWith("mailto:") || href.startsWith("tel:")) {
    return (
      <a href={href} target={target} rel={rel} {...rest}>
        {children}
      </a>
    );
  }

  const finalTarget = target ?? "_blank";
  const finalRel =
    rel ?? (finalTarget === "_blank" ? "noopener noreferrer" : undefined);
  return (
    <a href={href} target={finalTarget} rel={finalRel} {...rest}>
      {children}
    </a>
  );
}

export const markdownComponents: Components = {
  a: MarkdownLink as Components["a"],
};
